import { TabGroup, TabPanels, TabPanel } from '@headlessui/react';
import React, { useEffect, useState } from 'react';
import PageEditNavigation from './PageEditNavigation';
import clsx from 'clsx';
import { Route, Switch, useLocation, useRouteMatch, Redirect } from 'react-router-dom';

export default function PageEditView({ tabs }) {
  const match = useRouteMatch();
  const location = useLocation();

  /**
   * If no match, its probably the `''` path.
   * If its not the `''` path, its probably an old or invalid url and we redirect back
   * to the base path of the tabs
   */
  const findTabIndex = () => {
    const currentTab = `/${location.pathname.split('/').pop()}`;
    const tabIndex = tabs.findIndex(tab => tab.path === currentTab);
    return tabIndex === -1 ? 0 : tabIndex;
  };

  const [tabIndex, setTabIndex] = useState(findTabIndex());

  useEffect(() => {
    const tabIndex = findTabIndex();
    setTabIndex(tabIndex);
  }, [match]);

  const defaultPath = tabs[0].path;

  return (
    <TabGroup selectedIndex={tabIndex}>
      <div className="flex flex-col">
        {tabs.length > 1 && (
          <div className="md:fixed md:border-r border-gray-100 w-56 -ml-4 px-4 pt-4 h-full">
            <PageEditNavigation tabs={tabs} />
          </div>
        )}

        <div
          className={clsx('px-4 pt-6 pb-16', {
            'md:ml-52': tabs.length > 1,
          })}
        >
          <TabPanels className="outline-none">
            <Switch>
              {tabs.map((tab, index) => (
                <Route exact path={`${match.url}${tab.path}`} key={index} as={TabPanel}>
                  <PageEditViewPanel tab={tab} />
                </Route>
              ))}

              <Redirect from={match.path} to={`${match.path}${defaultPath}`} />
            </Switch>
          </TabPanels>
        </div>
      </div>
    </TabGroup>
  );
}

export function PageEditViewPanel({ tab }) {
  return (
    <div
      className={clsx({
        'max-w-lg': tab.width === 'lg',
        'max-w-xl': tab.width === 'xl',
        'max-w-2xl': tab.width === '2xl',
        'max-w-3xl': tab.width === '3xl',
        'max-w-4xl': tab.width === '4xl',
      })}
    >
      <h2 className="text-2xl mb-2">{tab.title || tab.label}</h2>

      <div className="mb-4 text-gray-700">{tab.description}</div>

      {tab.component}
    </div>
  );
}
